(function () {
  function initProductGallery(root) {
    var strip = root.querySelector('[data-ppd-thumb-strip]');
    var thumbs = (strip || root).querySelectorAll('[data-ppd-thumb]');
    var panels = root.querySelectorAll('.ppd-product-media');
    /* PPD gallery-lightbox lane: live status hook (ADD — thumb/panel toggling below untouched).
       The status shows a plain position counter; the on-image variant caption
       was removed as visual noise. */
    var liveStatus = root.querySelector('[data-product-gallery-status]');
    if (thumbs.length < 2) return;

    /* PPD gallery-lightbox lane: keep the single polite live region to the
       position counter instead of adding a second live region (ADD). */
    /* Thumbs can be re-ordered in the DOM (the strap thumb follows the active
       design), so the counter and arrow keys read the live order; the
       data-ppd-thumb index stays fixed because it pairs a thumb with its panel. */
    function liveThumbs() {
      return Array.prototype.slice.call((strip || root).querySelectorAll('[data-ppd-thumb]'));
    }
    function syncThumbStatus(thumb) {
      try {
        if (liveStatus) {
          var list = liveThumbs();
          var pos = list.indexOf(thumb) + 1 || 1;
          liveStatus.textContent = pos + ' / ' + list.length;
        }
      } catch (e) {}
    }
    var strapThumb = (strip || root).querySelector('[data-ppd-strap-thumb]');
    function keepStrapBeside(thumb) {
      if (!strapThumb || thumb === strapThumb || !thumb.parentNode) return;
      if (thumb.nextElementSibling !== strapThumb) thumb.parentNode.insertBefore(strapThumb, thumb.nextElementSibling);
    }

    function selectThumb(thumb) {
      var idx = thumb.getAttribute('data-ppd-thumb');
      thumbs.forEach(function (item) {
        var active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var panelIdx = panel.id.split('-').pop();
        var active = panelIdx === idx;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      keepStrapBeside(thumb);
      /* PPD gallery-lightbox lane: status sync on thumb change (ADD). */
      syncThumbStatus(thumb);
      /* Keep the active thumb visible in the snap strip. */
      try {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      } catch (e) {}
    }

    thumbs.forEach(function (thumb, index) {
      thumb.tabIndex = index === 0 ? 0 : -1;
      thumb.addEventListener('click', function () {
        selectThumb(thumb);
      });
      thumb.addEventListener('keydown', function (event) {
        var nextIndex;
        var list = liveThumbs();
        var position = list.indexOf(thumb);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (position - 1 + list.length) % list.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (position + 1) % list.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = list.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        var nextThumb = list[nextIndex];
        selectThumb(nextThumb);
        nextThumb.focus();
      });
    });

    /* PPD gallery-lightbox lane: initial counter sync from the server-rendered
       position (ADD). */
    try {
      var activeThumb = root.querySelector('[data-ppd-thumb].is-active') || thumbs[0];
      if (activeThumb && liveStatus) {
        var initialPos = activeThumb.getAttribute('data-ppd-thumb') || '1';
        liveStatus.textContent = initialPos + ' / ' + thumbs.length;
      }
    } catch (e) {}
  }

  function initVariantPicker(root) {
    var select = root.querySelector('[data-ppd-variant-select]');
    if (!select) return;

    var productRoot = root.closest('.ppd-product') || root;
    var prices = productRoot.querySelectorAll('[data-ppd-current-price]');
    var comparePrice = productRoot.querySelector('[data-ppd-compare-price]');
    var buttons = root.querySelectorAll('[data-ppd-add-to-cart]');
    var chips = root.querySelectorAll('.variant-chip');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var available = option.dataset.available === 'true';
      prices.forEach(function (price) { price.textContent = option.dataset.price; });
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice;
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      buttons.forEach(function (button) {
        /* Preorder-with-window and made-to-order pieces stay buyable at
           tracked-zero inventory. The button carries the server's purchase
           state; raw availability alone must not re-disable it. */
        var canBuy = available || option.dataset.purchasable === 'true' || button.dataset.ppdPurchasable === 'true';
        button.disabled = !canBuy;
        button.textContent = canBuy ? button.dataset.ppdAddLabel : 'Sold out';
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      syncFitPanels(option);
    });

    /* What-fits panels are rendered per Size value; the one matching the
       selected variant's title shows. Products without a Size option render
       a single panel with no size attribute, which this leaves alone. */
    var fitGuide = productRoot.querySelector('[data-ppd-fit-guide]');
    function syncFitPanels(option) {
      if (!fitGuide || !option) return;
      var parts = (option.textContent || '').split('\u00B7')[0].split(' / ').map(function (part) { return part.trim(); });
      fitGuide.querySelectorAll('[data-ppd-fit-panel][data-ppd-fit-size]').forEach(function (panel) {
        panel.hidden = parts.indexOf(panel.getAttribute('data-ppd-fit-size')) === -1;
      });
    }

    /* "Choose Large" inside the panel is a real link to the other size's
       variant; with the picker on the page it becomes an in-page chip click
       so the price, gallery, and panel all follow without a reload. */
    if (fitGuide) {
      fitGuide.querySelectorAll('[data-ppd-fit-switch]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var size = link.getAttribute('data-ppd-fit-switch');
          var chip = null;
          chips.forEach(function (candidate) {
            if (!chip && candidate.getAttribute('data-variant') === size && !candidate.disabled) chip = candidate;
          });
          if (!chip) return;
          event.preventDefault();
          chip.click();
          chip.focus();
        });
      });
    }
    /* Resolves the variant matching every group's checked chip, in option
       order. Chips only carry their own option value, so intersecting the
       groups is what keeps design, hardware, and strap combined instead of
       jumping to one chip's representative variant. Returns null when a
       group has no checked chip or no variant matches. */
    function resolveVariantFromChips() {
      var fields = root.querySelectorAll('.variant-field');
      if (!fields.length) return null;
      var wanted = [];
      var complete = true;
      Array.prototype.forEach.call(fields, function (field) {
        var group = parseInt(field.getAttribute('data-option-group'), 10);
        var checked = field.querySelector('.variant-chip[aria-checked="true"]');
        if (!checked || isNaN(group)) {
          complete = false;
          return;
        }
        var value = checked.getAttribute('data-variant') || '';
        if (!value) complete = false;
        wanted[group - 1] = value.trim();
      });
      if (!complete) return null;
      /* Compare whole titles: joining is exact even when an option value
         itself contains a slash (e.g. "Fuschia/Pink Gold Honeycomb"). */
      var wantedTitle = wanted.join(' / ');
      var options = select.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        var fullTitle = (options[i].textContent || '').split('\u00B7')[0].trim();
        if (fullTitle === wantedTitle) return options[i];
      }
      return null;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        chip.closest('.variant-chips').querySelectorAll('.variant-chip').forEach(function (optionChip) {
          optionChip.setAttribute('aria-checked', optionChip === chip ? 'true' : 'false');
        });

        /* Combinatorial selection: resolve the variant matching all groups'
           checked chips. Falls back to the clicked chip's representative
           variant only when no exact combination exists. */
        var selectedOption = resolveVariantFromChips()
          || select.querySelector('option[value="' + chip.value + '"]');
        if (!selectedOption) return;

        select.value = selectedOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        /* Only the primary option (Design, position 1) drives the gallery.
           Hardware/strap choices reuse the design photography — their
           representative variant's media would yank the focused image to a
           different design, and we have no per-combination images. */
        var drivesGallery = chip.getAttribute('data-option-position') === '1';

        /* The design is the piece: the collection card named it, so the
           heading and the breadcrumb leaf follow the selection instead of
           keeping the family name the shopper never clicked. The string is
           rendered by product-display-title in Liquid, so there is no second
           copy of the naming rule here. */
        if (drivesGallery && chip.dataset.displayTitle) {
          /* Both the H1 and the mobile sticky-bar title mirror carry this
             attribute (see blocks/_ppd-product-identity.liquid and
             _ppd-product-details.liquid's .product-sticky-cta__title), so a
             shopper scrolled past the heading still sees what they're adding. */
          document.querySelectorAll('[data-ppd-display-title]').forEach(function (heading) {
            heading.textContent = chip.dataset.displayTitle;
          });
          var crumbLeaf = document.querySelector('.ppd-breadcrumbs__list [aria-current="page"]');
          if (crumbLeaf) crumbLeaf.textContent = chip.dataset.displayTitle;
        }

        if (drivesGallery && chip.dataset.mediaId) {
          var thumb = document.querySelector('[data-product-gallery] [data-ppd-thumb][data-media-id="' + chip.dataset.mediaId + '"]');
          if (thumb) thumb.click();
          /* The sticky bar's own thumbnail is a plain img, not a gallery
             pane — mirror whichever image the clicked gallery thumb carries
             so the sticky bar never shows a stale design after a chip swap. */
          var stickyThumb = document.querySelector('.product-sticky-cta__thumb');
          var sourceImg = thumb && thumb.querySelector('img');
          if (stickyThumb && sourceImg) {
            stickyThumb.src = sourceImg.src;
            if (sourceImg.srcset) stickyThumb.srcset = sourceImg.srcset;
          }
        }

        /* PPD gallery-lightbox lane: live-region + lightbox sync on chip change
           (ADD — price logic above untouched). The stage shows a plain position
           counter; the full variant title still feeds the lightbox caption. */
        try {
          var chipTitle = '';
          if (selectedOption) {
            chipTitle = (selectedOption.textContent || '').split('\u00B7')[0].trim();
          }
          if (!chipTitle) {
            chipTitle = chip.getAttribute('data-variant') || '';
          }
          var gallery = document.querySelector('[data-product-gallery]');
          if (gallery) {
            var status = gallery.querySelector('[data-product-gallery-status]');
            if (status) {
              var thumbs = gallery.querySelectorAll('[data-ppd-thumb]');
              var active = gallery.querySelector('[data-ppd-thumb].is-active') || gallery.querySelector('[data-ppd-thumb].active');
              var pos = active ? active.getAttribute('data-ppd-thumb') : '1';
              status.textContent = thumbs.length > 1 ? pos + ' / ' + thumbs.length : pos;
            }
          }
          var lightboxVariant = document.querySelector('[data-pdp-lightbox-variant]');
          if (lightboxVariant && chipTitle) lightboxVariant.textContent = chipTitle;
          var lightboxPrice = document.querySelector('[data-pdp-lightbox-price]');
          if (lightboxPrice && selectedOption && selectedOption.dataset && selectedOption.dataset.price) {
            lightboxPrice.textContent = selectedOption.dataset.price;
          }
        } catch (e) {}
      });
    });

    /* Roving tabindex per chip radiogroup: one tab stop per option group,
       arrows/Home/End move and select. Reuses the click handler above so
       price, caption, and gallery sync stay in one path. */
    try {
      var groups = {};
      chips.forEach(function (chip) {
        var group = chip.closest('.variant-chips');
        if (!group) return;
        if (!group.hasAttribute('data-ppd-roving')) {
          group.setAttribute('data-ppd-roving', 'true');
          initChipRoving(group);
        }
      });
    } catch (e) {}

    function initChipRoving(group) {
      var groupChips = Array.prototype.slice.call(group.querySelectorAll('.variant-chip'));
      if (groupChips.length < 2) return;

      function syncRoving() {
        var checked = group.querySelector('.variant-chip[aria-checked="true"]') || groupChips[0];
        groupChips.forEach(function (item) {
          item.tabIndex = item === checked ? 0 : -1;
        });
      }

      syncRoving();
      group.addEventListener('click', syncRoving);

      group.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'ArrowUp' && key !== 'ArrowDown' && key !== 'Home' && key !== 'End') return;
        var current = document.activeElement;
        var index = groupChips.indexOf(current);
        if (index === -1) return;
        event.preventDefault();
        var next;
        if (key === 'Home') {
          next = 0;
        } else if (key === 'End') {
          next = groupChips.length - 1;
        } else {
          var direction = key === 'ArrowLeft' || key === 'ArrowUp' ? -1 : 1;
          next = (index + direction + groupChips.length) % groupChips.length;
        }
        var nextChip = groupChips[next];
        nextChip.focus();
        nextChip.click();
      });
    }

  }

  function init() {
    document.querySelectorAll('.ppd-product-gallery').forEach(initProductGallery);
    document.querySelectorAll('.ppd-product-details').forEach(initVariantPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
